const mod = require('../../bahabot.module.js');
const { RESOURCE_TYPE_CHANNEL } = require('../../services/discord.service.js');

/**
 * @param {angular.IQService} $q 
 */
function bbDiscordController(DiscordService, EventSourceService, $http, $q) {
    this.localId = 0;

    this.nextId = () => {
        this.localId++;
        return this.localId;
    }

    this.test = "";

    this.streamStatus = {
        twitch: null,
        kick: null,
        youtube: null,
    };

    this.streamSSE = null;

    this.data = {
        roles: [],
        clipTargets: [],
        videoTargets: [],
        xTweetTargets: [],
        streamNotifications: [],
    }

    this.sendMsg = {
        channelId: "",
        message: "",
    }

    this.sendMessage = () => {
        const res = DiscordService.decode(this.sendMsg.channelId);
        if (!res.isValid || res.primaryType !== RESOURCE_TYPE_CHANNEL) return;

        $q.when(DiscordService.Message.post({ channelId: res.primaryValue }, this.sendMsg.message)).then(() => {
            this.sendMsg.message = "";
        })
    }

    this.loading = true;

    DiscordService.All().then(v => {
        this.data = v;
        this.loading = false;
    })

    $http.get('/api/protected/stream-state').then(res => {
        this.streamStatus = res.data;
    });

    this.streamSSE = EventSourceService.connect("/api/protected/stream-state/live");

    this.streamSSE.on('stream_state', (data) => {
        this.streamStatus = data;
    });

    this.$onDestroy = () => {
        this.streamSSE?.close();
        this.streamSSE = null;
    }

    this.addRoleDef = () => {
        this.data.roles.push({
            id: this.nextId(),
            emoteName: '',
            messageId: '',
            roleName: ''
        })
    }

    this.deleteRoleDef = (role) => {
        this.data.roles = this.data.roles.filter(r => r.id !== role.id)
    }

    this.addClipTargetDef = () => {
        this.data.clipTargets.push({
            id: this.nextId(),
            targetChannelId: ''
        })
    }

    this.deleteClipTargetDef = (target) => {
        this.data.clipTargets = this.data.clipTargets.filter(ct => ct.id !== target.id)
    }

    this.addVideoTargetDef = () => {
        this.data.videoTargets.push({
            id: this.nextId(),
            targetChannelId: ''
        })
    }

    this.deleteVideoTargetDef = (target) => {
        this.data.videoTargets = this.data.videoTargets.filter(ct => ct.id !== target.id)
    }

    this.addXTweetTargetDef = () => {
        this.data.xTweetTargets.push({
            id: this.nextId(),
            targetChannelId: ''
        })
    }

    this.deleteXTweetTargetDef = (target) => {
        this.data.xTweetTargets = this.data.xTweetTargets.filter(ct => ct.id !== target.id)
    }

    this.addStreamNotificationDef = () => {
        this.data.streamNotifications.push({
            id: this.nextId(),
            platform: 'twitch',
            targetChannelId: '',
            messageTemplate: '',
            mentionRoleIds: '[]',
        })
    }

    this.deleteStreamNotificationDef = (notif) => {
        this.data.streamNotifications = this.data.streamNotifications.filter(n => n.id !== notif.id)
    }

    this.extractGuildId = (resourcePath) => {
        if (!resourcePath) return ''
        const parts = resourcePath.split('/')
        if (parts.length >= 2 && parts[0] === 'guild') return parts[1]
        return ''
    }

    this.saveAll = () => {
        this.loading = true;

        $q.all([
            DiscordService.ReactionRoles.post(this.data.roles),
            DiscordService.ClipTargets.post(this.data.clipTargets),
            DiscordService.VideoTargets.post(this.data.videoTargets),
            DiscordService.XTweetTargets.post(this.data.xTweetTargets),
            DiscordService.StreamOnlineNotifications.post(this.data.streamNotifications),
        ]).then(([roles, clipTargets, videoTargets, xTweetTargets, streamNotifications]) => {
            this.loading = false;
            this.data.roles = roles;
            this.data.clipTargets = clipTargets;
            this.data.videoTargets = videoTargets;
            this.data.xTweetTargets = xTweetTargets;
            this.data.streamNotifications = streamNotifications;
        })
    }
}

mod.component('bbDiscord', {
    templateUrl: 'tpl/bb-discord.component.html',
    bindings: {},
    controller: ['DiscordService', 'EventSourceService', '$http', '$q', '$scope', bbDiscordController]
});